<template>
  <div>
    <v-col cols="12" class="text-center">
      <h3 class="mb-4">¿Está seguro de que desea archivar este expediente?</h3>
      <TextButton @click="confirmArchiving"> Confirmar </TextButton>
    </v-col>
  </div>
</template>

<script>
import TextButton from '@src/components/base/TextButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  name: 'ConfirmacionArchivadoDialogComponent',
  components: {
    TextButton,
  },
  data() {
    return {
      DIALOG_TYPES,
    }
  },
  props: {
    dialog: { type: Boolean, default: false },
    onConfirm: { type: Function, required: true },
  },
  methods: {
    confirmArchiving() {
      this.onConfirm()
    },
  },
}
</script>
